<template>
  <q-icon
    name="mdi-autorenew"
    class="sync-spinner"
    :size="size"
    :class="{'infinite': infinite}"
  />
</template>

<script>
export default {
  props: {
    infinite: {
      type: Boolean,
      default: true
    },
    size: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">
@keyframes spin {
  to {
    transform: rotate(180deg);
  }
}

.sync-spinner {
  transform: rotate(0deg);
  animation: spin 1.5s ease-out 1;

  &.infinite {
    animation-iteration-count: infinite;
  }
}
</style>
